import { createReducer, on } from '@ngrx/store';
import { orderEntityAdapter as EntityAdapter, initialState } from './order.state';
import { OrderActions as Actions } from './order.actions';

export const orderReducer = createReducer(
    initialState,

    on(Actions.loadPage, (state) => ({
        ...state,
        isLoading: true,
    })),

    on(Actions.loadPageSuccess, (state, { resultWithPageInfo, correlationId }) => {
        if (!correlationId)
            return EntityAdapter.setAll(resultWithPageInfo.entities, {
                ...state,
                isLoading: false,
                error: undefined,
                currentPage: resultWithPageInfo.pageInfo,
            });

        return EntityAdapter.setAll(resultWithPageInfo.entities, {
            ...state,
            isLoading: false,
            error: undefined,
            currentPage: resultWithPageInfo.pageInfo,
            history: [...state.history, { correlationId, payload: resultWithPageInfo }],
        });
    }),

    on(Actions.loadPageFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(Actions.loadSingle, (state) => ({
        ...state,
        isLoading: true,
    })),

    on(Actions.loadSingleSuccess, (state, { entity, correlationId }) => {
        if (!correlationId)
            return EntityAdapter.setOne(entity, {
                ...state,
                isLoading: false,
                error: undefined,
            });

        return EntityAdapter.setOne(entity, {
            ...state,
            isLoading: false,
            error: undefined,
            history: [...state.history, { correlationId, payload: entity }],
        });
    }),

    on(Actions.loadSingleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(Actions.setCurrentEntityId, (state, { entityId }) => ({
        ...state,
        currentEntityId: entityId,
    })),

    on(Actions.deselectCurrent, (state) => ({
        ...state,
        currentEntityId: undefined,
    }))
);
